import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

export interface IResetPasswordRequestAction {
  data: {
    confirmNewPassword: string;
    newPassword: string;
    resetPasswordToken: string;
    userData: {
      client: string;
      token: string;
      uid: string;
    };
  };
  functions: {
    error: (err: any) => void;
    goBack: () => void;
  };
}

function resetPasswordRequest(
  draft: Draft<IAuthData>,
  _: PayloadAction<IResetPasswordRequestAction>,
) {
  draft.resetPassword.config.isLoading = true;
}

export default resetPasswordRequest;
